module.exports = __webpack_public_path__ + "static/media/ckinnisvara.d97b9754.svg";